import React, { useState } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import "./ResetPassword.css";
import loginLogo from "../../assets/loginLogo.png";
import topLeftIcon from "../../assets/topLeft.png";
import bottomLeftIcon from "../../assets/bottomLeft.png";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import emailIcon from "../../assets/emailIcon.png";
import passwordIcon from "../../assets/passwordIcon.png";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import nextIcon from "../../assets/nextIcon.png";
import forgetPassword from "../../assets/forgetPassword.png";
import topRightIcon from "../../assets/topRight.png";
import bottomRightIcon from "../../assets/bottomRight.png";
import isValidEmail from "../../utils";
// import action from "./action";
import { AppContext } from "../../context/crmContext";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useNavigate } from "react-router-dom";
import action from "./action";


const ResetPassword = () => {
  const [userName, setUserName] = useState("");
  const [isOTPSent, setIsOTPSent] = useState(false);
  const [otp, setOtp] = useState("");
  const { getResetOTP, verifyResetOTP, passwordReset } = action;
  const [isResetPasswordEnable, setIsResetPasswordEnable] = useState(false);
  const [password, setPassword] = useState("");
  const [reEnteredNewPassword, setReEnteredNewPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const navigate = useNavigate();

  const getUserName = (value) => {
    setUserName(() => value);
  };

  const getOTP = () => {
    if (userName) {
      const payload = {
        email: userName,
      };
      getResetOTP(payload, getResetDetails);
    }
  };

  const getResetDetails = (value) => {
    if (value.statusCode == "200") {
      setIsOTPSent(() => true);
    }
  };

  const enterOTP = (value) => {
    setOtp(() => value);
  };

  const verifyOTP = () => {
    const payload = {
      email: userName,
      otp: otp,
    };
    verifyResetOTP(payload, getVerificationDetails);
  };

  const getVerificationDetails = (value) => {
    setIsResetPasswordEnable(() => true);
  };

  const enterNewPassword = (value) => {
    setPassword(() => value);
  };

  const reEnterNewPassword = (value) => {
    setReEnteredNewPassword(() => value);
  };

  const enterOldPassword = (value) => {
    setOldPassword(() => value);
  };

  const resetPasswordConfirmation = () => {
    if (password === reEnteredNewPassword) {
      const payload = {
        email: userName,
        newpassword: password,
      };
      passwordReset(payload, getPasswordResetDetails);
    }
  };

  const getPasswordResetDetails = (value) => {
    if(value.statusCode == "200"){
        navigate("/")
    }
  };

  return (
    <div>
      <Container maxWidth="100%" style={{ padding: "0px" }}>
        <img className="top-left-image" src={topLeftIcon} />
        <img className="bottom-left-image" src={bottomLeftIcon} />
        <img className="top-right-image" src={topRightIcon} />
        <img className="bototm-right-image" src={bottomRightIcon} />
        <Box sx={{ bgcolor: "#3166a6", height: "50vh" }} />
        <Box sx={{ bgcolor: "#e4f8ff", height: "50vh" }} />
        <Box className={"login-area"}>
          <img src={loginLogo} width="100%" />
          <hr className="logo-divider"></hr>
          {!isResetPasswordEnable ? (
            <>
              <InputLabel
                style={{ marginLeft: "7px", marginTop: "2vh" }}
                htmlFor="input-with-icon-adornment"
              >
                Username
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  //   error={!isUserNameValid}
                  className="login-input"
                  id="outlined-start-adornment"
                  sx={{ width: "46ch" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img height="24px" width="24px" src={emailIcon} />
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => getUserName(e.target.value)}
                />
              </FormControl>
              {isOTPSent && (
                <>
                  <InputLabel
                    style={{ marginLeft: "7px" }}
                    htmlFor="input-with-icon-adornment"
                  >
                    OTP
                  </InputLabel>
                  <FormControl variant="standard" sx={{ m: 1 }}>
                    <TextField
                      type="password"
                      className="login-input"
                      id="outlined-start-adornment"
                      sx={{ width: "46ch" }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <img
                              height="24px"
                              width="24px"
                              src={passwordIcon}
                            />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => enterOTP(e.target.value)}
                    />
                  </FormControl>
                </>
              )}
            </>
          ) : (
            <>
              <InputLabel
                style={{ marginLeft: "7px", marginTop: "2vh" }}
                htmlFor="input-with-icon-adornment"
              >
                Old Password
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  //   error={!isUserNameValid}
                  className="login-input"
                  id="outlined-start-adornment"
                  sx={{ width: "46ch" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img height="24px" width="24px" src={emailIcon} />
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => enterOldPassword(e.target.value)}
                />
              </FormControl>
              <InputLabel
                style={{ marginLeft: "7px", marginTop: "2vh" }}
                htmlFor="input-with-icon-adornment"
              >
                New Password
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  //   error={!isUserNameValid}
                  className="login-input"
                  id="outlined-start-adornment"
                  sx={{ width: "46ch" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img height="24px" width="24px" src={emailIcon} />
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => enterNewPassword(e.target.value)}
                />
              </FormControl>
              <InputLabel
                style={{ marginLeft: "7px", marginTop: "2vh" }}
                htmlFor="input-with-icon-adornment"
              >
                Re-Enter New Password
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  //   error={!isUserNameValid}
                  className="login-input"
                  id="outlined-start-adornment"
                  sx={{ width: "46ch" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img height="24px" width="24px" src={emailIcon} />
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => reEnterNewPassword(e.target.value)}
                />
              </FormControl>
            </>
          )}
          {!isOTPSent ? (
            <Button
              className="send-button"
              style={{
                width: "98%",
                marginTop: "2vh",
                marginBottom: "3vh",
                background: "#ff867a",
                justifyContent: "space-between",
                height: "52px",
                marginLeft: "1vh",
              }}
              variant="contained"
              endIcon={<img src={nextIcon} height="16px" width="16px" />}
              onClick={() => getOTP()}
            >
              Get OTP
            </Button>
          ) : isResetPasswordEnable ? (
            <Button
              className="send-button"
              style={{
                width: "98%",
                marginTop: "2vh",
                marginBottom: "3vh",
                background: "#ff867a",
                justifyContent: "space-between",
                height: "52px",
                marginLeft: "1vh",
              }}
              variant="contained"
              endIcon={<img src={nextIcon} height="16px" width="16px" />}
              onClick={() => resetPasswordConfirmation()}
            >
              Reset Password
            </Button>
          ) : (
            <Button
              className="send-button"
              style={{
                width: "98%",
                marginTop: "2vh",
                marginBottom: "3vh",
                background: "#ff867a",
                justifyContent: "space-between",
                height: "52px",
                marginLeft: "1vh",
              }}
              variant="contained"
              endIcon={<img src={nextIcon} height="16px" width="16px" />}
              onClick={() => verifyOTP()}
            >
              Verify OTP
            </Button>
          )}
        </Box>
      </Container>
    </div>
  );
};

export default ResetPassword;
